import styled from 'styled-components';

export const OtpBlockInnerHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    `
);

export const OtpBlockWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `
)

export const OtpBlockInnerHeadText = styled.p(
    props => `
        font-size: 1.6rem;
        color: #4a4a4a;
        font-weight: bold;
    `
);

export const OtpBlockResendText = styled.a(
    props => `
        font-size: 1.6rem;
        color: #0091ff;
        font-weight: 900;
        text-decoration:none;
    `
);

export const OtpMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-top: ${props.theme.spacing.large.l15};
        padding-bottom: ${props.theme.spacing.large.l15};
    `,
);

export const PasswordBlockWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        margin: 2rem 0;
        justify-content: space-between;
    `
);

export const PasswordClickWrap = styled.div(
    props => `
        display: flex;
    `
);

export const PasswordText = styled.a(
    props => `
        text-decoration: none;
        font-size:1.6rem;
        color: #0091ff;
        font-weight: 900;
        cursor: pointer;
    `
);

export const PasswordResetWrap = styled.div(
    props => `
        display: flex;
        justify-content: flex-end;
    `
);

export const PasswordReset = styled.a(
    props => `
        text-decoration: none;
        font-size:1.6rem;
        color: #0091ff;
        font-weight: 900;
        cursor: pointer;
    `
);

export const HeadSubTitleText = styled.p(
    props => `
          font-size: ${props.theme.font.large.font14};
          color: ${props.theme.colors.red.base};
          padding-top:${props.theme.spacing.small.s5};
          margin-top: ${props.theme.spacing.small.s5};
          letter-spacing: ${props.theme.font.letterSpacing.base};
          @media only screen and (min-width:320px) and (max-width: 991px){
              font-size: ${props.theme.font.large.font14};
          }
      `,
);

export const HeadSubTitleTextSpan = styled.span(
props => `
        // background-color: ${props.theme.colors.grey.lighte7};
        padding: ${props.theme.spacing.small.s8};
        display: inline-flex;
    `,
);

export const EyeWrapper = styled.div(
    props => `
      position: absolute;
      height: 42px;
      right: 0;
      top: 0;
      display: flex;
      aling-items: center;
      justidy-content: center;
      border-radius: 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0;
    `
);
